// Module
var code = "<md-icon class=\"material-icons md-{{ ::size }} work-order-priority-icon work-order-priority-icon--emergency\">notifications_active</md-icon> ";
// Exports
module.exports = code;